import { Role, type User } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { useAppContext } from '../../hooks/useAppContext';
import { usePermission } from '../../hooks/usePermission';
import { UserDeleteModal } from './UserDeleteModal';

interface Props {
  user: User;
}

export const UserDeleteMenuItem = (props: Props) => {
  const { user } = props;
  const { organization } = useAppContext();
  const hasPermission = usePermission('delete', 'user');

  const membership = user.organizationMemberships.find(
    (m) => m.organizationId === organization.id,
  );
  const targetIsSupport = membership?.roles.includes(Role.Support) ?? false;

  const disabled = !hasPermission || targetIsSupport;

  const onClick = () => {
    showModal(UserDeleteModal, { userId: user.id, userName: user.name });
  };

  return (
    <ChakraV3.MenuItem value='delete' disabled={disabled} onClick={onClick} color='danger'>
      <FaRegTrashAlt />
      Delete
    </ChakraV3.MenuItem>
  );
};
